import { Component, DestroyRef, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { map } from 'rxjs';
import { WarehouseArticleResumee, GroupItemLabel } from '../../../models/new/warehouse-article-resumee';
import { GraphQLService } from 'src/app/services/graph-ql.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { SnackbarType } from 'src/app/shared/components/snackbar/snackbar.component';
import { DatabaseQueries } from 'src/app/shared/types/get-query';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
	selector: 'bt-warehouse-article-resumee-modal',
	standalone: false,
	templateUrl: './warehouse-article-resumee-modal.component.html',
	styleUrl: './warehouse-article-resumee-modal.component.scss'
})
export class WarehouseArticleResumeeModalComponent {
	readonly dialogRef = inject(MatDialogRef<WarehouseArticleResumeeModalComponent>);
	readonly data = inject(MAT_DIALOG_DATA);
	readonly #destroyRef = inject(DestroyRef);

	loading = true;
	articleResumees: WarehouseArticleResumee[] = [];
	title = 'Warehouses';

	constructor(
		private graphQlService: GraphQLService,
		private utilitiesService: UtilitiesService
	) {
		this.title = this.data?.title ?? 'Warehouses';
		this.loadResumee();
	}

	loadResumee() {
		this.loading = true;

		this.graphQlService
			.getData(DatabaseQueries.GET_WAREHOUSE_ARTICLE_RESUMEE_TABLE, { modelId: this.data.modelId })
			.pipe(
				takeUntilDestroyed(this.#destroyRef),
				map((res: any) =>
					(res?.data?.warehouseArticleResumeeTable ?? []).map(
						(row: any) =>
							new WarehouseArticleResumee({
								warehouse: new GroupItemLabel(row.warehouse),
								color: new GroupItemLabel(row.color),
								sizes: row.sizes?.map((size: any) => new GroupItemLabel(size)) ?? []
							})
					)
				)
			)
			.subscribe({
				next: (data: WarehouseArticleResumee[]) => {
					this.articleResumees = data;
					this.loading = false;
				},
				error: (err) => {
					this.utilitiesService.showSnackbar('Error fetching warehouse availability', SnackbarType.Error);
					console.error(err);
					this.loading = false;
				}
			});
	}

	getSizesLabel(sizes?: GroupItemLabel[]): string {
		return (sizes ?? []).map((size) => size.label).join(', ');
	}

	close() {
		this.dialogRef.close(null);
	}
}
